import { Grid } from '@mui/material';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { useState } from 'react';
import PostalCreateView from '../../../components/application/create/postal_rec/PostalCreateView';
import PostalListView from '../../../components/application/create/postal_rec/PostalListView';

const PostalReceiveCreateListView = () => {
    const [onURL, setOnURL] = useState(AppURL.ApplicationURL + 'app/postal/receive/add/create/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = ():void => {
        refetch(); 
    };
   
  return (
    <Grid container spacing={3}>
        <Grid item xl={3} md={4} sm={12} xs={12} lg={4}>
            <PostalCreateView handleFormSuccess={handleFormSuccess} />
        </Grid>
        <Grid item xl={9} md={8} sm={12} xs={12} lg={8}>
            <PostalListView handleFormSuccess={handleFormSuccess} setOnURL={setOnURL} data={data} loading={loading} error={error} />
        </Grid>
    </Grid>
  )
}

export default PostalReceiveCreateListView